<template>
  <b-overlay :show="loading">
    <b-card>
      <b-row>
        <b-col cols="12" class="mb-1">
          <h5 class="mb-25">Data Pengembalian</h5>
          <p class="text-body mb-0">
            Riwayat request pengembalian stok dari mobil ke gudang.
          </p>
        </b-col>
        <b-col sm="12" md="3" class="my-1">
          <b-form-group label="Per halaman" label-for="perPageSelectPengembalian" class="mb-0">
            <b-form-select
              id="perPageSelectPengembalian"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12" md="5" class="my-1">
          <b-form-group label="Cari" label-for="filterInputPengembalian" class="mb-0">
            <b-input-group size="sm">
              <b-form-input
                id="filterInputPengembalian"
                v-model="filter"
                type="search"
                placeholder="Cari no. pengembalian / keterangan..."
              />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <!-- table -->
        <b-col cols="12">
          <b-table
            striped
            small
            hover
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="pengembalians"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="tableFilter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #head(checkbox)>
              <b-form-checkbox v-model="allChecked" />
            </template>
            <template #cell(checkbox)="{ item }">
              <b-form-checkbox v-model="checkedPengembalian" :value="item" />
            </template>
            <template #cell(order)="{ index }">
              {{ index + 1 }}
            </template>
            <template #cell(tanggal)="{ item }">
              {{ humanDate(item.tanggal) }}
            </template>
            <template #cell(aksi)="{ item }">
              <div class="d-inline-flex align-items-center text-nowrap">
                <b-button
                  size="sm"
                  class="mr-50"
                  variant="outline-info"
                  @click.prevent="viewDetail(item)"
                >
                  <feather-icon icon="EyeIcon" />
                </b-button>
                <b-dropdown
                  size="sm"
                  variant="link"
                  toggle-class="text-decoration-none p-0"
                  menu-class="pengembalian-aksi-dropdown"
                  no-caret
                  right
                  :dropup="pengembalians.length <= 3"
                  boundary="viewport"
                  :popper-opts="{ positionFixed: true }"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="text-body align-middle"
                    />
                  </template>
                  <b-dropdown-item @click.prevent="printPengembalian(item.id)">
                    Cetak
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="isSales"
                    @click.prevent="remove(item)"
                  >
                    Hapus
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </template>
          </b-table>
        </b-col>
        <!-- / -->
        <!-- pagination -->
        <b-col cols="12" class="d-flex justify-content-between align-items-center mt-1">
          <small class="text-muted">Total {{ totalRows }} data</small>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            size="sm"
            class="my-0"
          />
        </b-col>
        <!-- / -->
      </b-row>
    </b-card>
  </b-overlay>
</template>
<script>
  import {
    BOverlay,
    BFormCheckbox,
    BPagination,
    BButton,
    BCard,
    BRow,
    BCol,
    BTable,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
  } from "bootstrap-vue";
  import mixin from '@/views/pages/pengembalian/mixin'
  export default {
    mixins: [mixin],
    components: {
      BOverlay,
      BFormCheckbox,
      BButton,
      BPagination,
      BCard,
      BRow,
      BCol,
      BTable,
      BFormGroup,
      BInputGroup,
      BInputGroupAppend,
      BFormInput,
      BFormSelect,
      BDropdown,
      BDropdownItem,
    },
    props: ["active"],
    computed: {
      gudangKendaraanId() {
        return this.$route.params.id;
      },
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter((f) => f.sortable)
          .map((f) => ({ text: f.label, value: f.key }));
      },
      tableFilter() {
        const value = this.filter;
        if (value === null || value === undefined) return undefined;
        const trimmed = String(value).trim();
        return trimmed || undefined;
      },
    },
    data: () => ({
      allChecked: false,
      checkedPengembalian: [],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      perPage: 10,
      pageOptions: [10, 30, 50, 100],
      loading: false,
      pengembalians: [],
      fields: [
        { key: "order", label: "No" },
        { key: "no", label: "No. Pengembalian" },
        { key: "tanggal", label: "Tanggal", sortable: true },
        { key: "sales.nama_lengkap", label: "Sales" },
        { key: "gudang.nama_gudang", label: "Gudang" },
        { key: "keterangan", label: "Keterangan" },
        { key: "aksi", label: "Aksi" },
      ],
      swalOptions: {
        title: `Anda Yakin?`,
        text: `Request Pengembalian Stok Barang Akan Dihapus?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Batal",
        customClass: {
          confirmButton: "btn btn-outline-success",
          cancelButton: "btn btn-danger ml-1",
        },
        buttonsStyling: false,
      },
    }),
    watch: {
      "$store.state.pengembalianbarang.isTabActive": {
        handler: function(val) {
          if(val) {
            this.getReturData()
          }
        },
        deep: true
      },
    },
    methods: {
      async printPengembalian(id) {
        try {
          this.loading = true
          const response = await this.print(id)
          this.loading = false
          await window.open(URL.createObjectURL(response))
          this.loading = false
        }
        catch(e) {
          this.loading = false
          this.displayError(e)
          return false
        }
      },
      viewDetail(item) {
        this.$emit("view", { component: "DetailPengembalian", pengembalian: item });
      },
      remove(item) {
        this.$swal(this.swalOptions).then(async (res) => {
          if (res.value) {
            try {
              this.loading = true;
              await this.$store.dispatch("pengembalianbarang/save", [{ id: item.id, fungsi: 2 }]);
              await this.getReturData();
              this.loading = false;
            } catch (e) {
              this.loading = false;
              this.displayError(e);
              return false;
            }
          }
        });
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      async getReturData() {
        const params = { order: "desc" };
        if (this.isSales) {
          params.id_sales = this.user.karyawan.id;
          params.id_gudang_m =
            this.$route.params.id || (this.myGudang && this.myGudang.id);
        }
        if (this.isAdminGudang && !this.isSales && this.myGudang) {
          params.id_gudang = this.myGudang.id;
        }
        this.loading = true;
        try {
          let rows = await this.$store.dispatch(
            "pengembalianbarang/getData",
            params
          );
          if (!Array.isArray(rows)) {
            rows = this.$store.state.pengembalianbarang.datas || [];
          }
          this.pengembalians = rows;
          this.totalRows = rows.length;
        } catch (e) {
          this.displayError(e);
          this.pengembalians = [];
          this.totalRows = 0;
        } finally {
          this.loading = false;
        }
      },
    },
    created() {
      this.getReturData();
    },
};
</script>

<style scoped>
/* Pastikan menu aksi tidak terpotong overflow table (terutama 1 baris) */
::v-deep .pengembalian-aksi-dropdown {
  z-index: 1080 !important;
}
</style>
